export const IndustryExpertiseHeader1 = `<div class=" common-details">
<div class="common-name"></div>
<div class="common-slider"></div>
        </div> `;
